import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { z } from 'zod';
import { loadConfig } from './config.ts';
import './styles.css';

// The CSP forbids eval; without this zod probes for it and logs a violation on every page.
z.config({ jitless: true });

const root = createRoot(document.getElementById('root')!);

loadConfig()
  .then(async () => {
    const { reportUncaughtErrors } = await import('./report-error.ts');
    reportUncaughtErrors();
    const { App } = await import('./app.tsx');
    root.render(<StrictMode><App /></StrictMode>);
  })
  .catch((e: unknown) => {
    root.render(
      <div className="center-screen">
        <div className="banner banner-bad">The app could not start: {e instanceof Error ? e.message : String(e)}</div>
      </div>,
    );
  });
